// extracted by css-extract-rspack-plugin
export default {"wrapper":"uDqoG","search_opened":"cEpWY","searchOpened":"cEpWY","results_anchor":"FcHpC","resultsAnchor":"FcHpC"};